import { minutesToMilliseconds } from '@sleepstation/utils'

// eslint-disable-next-line import/prefer-default-export
export const AUTH_TIMEOUT_DURATION = minutesToMilliseconds(1)
